import React, { useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { CloseIcon, FilterIcon, filterBlackIcon } from "../../../assets/images";
import Select from "react-select";
import { DropDownUserType } from "../../Jobs/RecurringJobReport/RecurringJobReportHeader";


type AppProps = {
 setClearFilter: (data: boolean) => void;
   setOffset: React.Dispatch<React.SetStateAction<number>>;
    finalBranchDataList: any;
     branch: DropDownUserType[];
     handleBranchDropDownChange: (data: any) => void;
     branchFetching: boolean;
     setBranchText: React.Dispatch<React.SetStateAction<string>>;
     setListBranch:React.Dispatch<React.SetStateAction<DropDownUserType>>
     listBranch:DropDownUserType
     setActiveListBranch:React.Dispatch<React.SetStateAction<DropDownUserType>>
     activeListBranch:DropDownUserType
     checkBottom:(e:any)=>void;
     toggle:boolean;
     setToggle:React.Dispatch<React.SetStateAction<boolean>>;
};



const HolidayCalenderFilter = ({
    setClearFilter,
    setOffset,
    finalBranchDataList,
    branch,
    handleBranchDropDownChange,
    branchFetching,
    setBranchText,
    setListBranch,
    listBranch,
    setActiveListBranch,
    activeListBranch,
    checkBottom,
    toggle,
    setToggle
}: AppProps) => {


  const resetFilterData = () => {
    // setActiveStatusValue(activeStatus.toString());
    setActiveListBranch(listBranch)
  };
  const handleSubmit = () => {
    setListBranch(activeListBranch)
    setClearFilter(false);
  };

  const onMenuClose = () => {
    // setLoadCondition(true);
    setOffset(0);
  };

  const handleListBranchDropDownChange=(data:any)=>{
    setActiveListBranch({label:data?.label,value:data?.value})
  }


  const clearFilter = () => {
    setListBranch({label:"Select...",value:null})
    setActiveListBranch({label:"Select...",value:null})
    setOffset(0);
    setClearFilter(true);
  };
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        resetFilterData();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="secondary"
        style={
          toggle || !listBranch?.value
            ? { border: "1px solid#bfcbe1" }
            : {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
        }
        outline
      >
        <img src={toggle ? FilterIcon : filterBlackIcon} alt="" />
      </DropdownToggle>

      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                setClearFilter(false);
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          <div className="mt-4 ml-1">
            <h4>Branch</h4>
            <div>
            <div className="col-md-12 p-0">
                        <label className="mb-1" htmlFor="">
                          Branch
                        </label>
                        <Select
                          options={
                            finalBranchDataList?.length
                              ? [
                                  ...finalBranchDataList
                                ]
                              : finalBranchDataList
                          }
                          value={activeListBranch}
                          onChange={(e) => handleListBranchDropDownChange(e)}
                          isSearchable={true}
                          isLoading={branchFetching}
                          onMenuClose={onMenuClose}
                          onMenuScrollToBottom={(e: any) => checkBottom(e)}
                          onInputChange={(e: any) => {
                            setBranchText(e);
                            setOffset(0);
                          }}
                        />
                      </div>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default HolidayCalenderFilter;
